import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import Iconify from 'src/components/iconify/Iconify';
import { Stack, padding } from '@mui/system';
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import { createOdooURL } from '../../routes/odooURL';

export default function ApplicationsPage() {
  const { translate } = useLocales();

  type IconifyIcon = string;

  interface CardData {
    icon: IconifyIcon;
    title: string;
    description: string;
    url?: string;
  }

  const cardsFinances: CardData[] = [
    {
      icon: 'mdi:book-account', // Icône représentant la comptabilité
      title: `${translate('upComingAppsPage.finance.accounting.title')}`,
      description: `${translate(
        'upComingAppsPage.finance.accounting.description'
      )}`,
      url: createOdooURL('accounting'),
    },
    {
      icon: 'mdi:receipt', // Icône représentant une facture
      title: `${translate('upComingAppsPage.finance.facturing.title')}`,
      description: `${translate(
        'upComingAppsPage.finance.facturing.description'
      )}`,
      url: createOdooURL('facturing'),
    },
    {
      icon: 'mdi:currency-usd', // Icône représentant de l'argent ou des transactions financières
      title: `${translate('upComingAppsPage.finance.expenses.title')}`,
      description: `${translate(
        'upComingAppsPage.finance.expenses.description'
      )}`,
      url: createOdooURL('expenses'),
    },
    {
      icon: 'mdi:folder', // Icône représentant des documents
      title: `${translate('upComingAppsPage.finance.document.title')}`,
      description: `${translate(
        'upComingAppsPage.finance.document.description'
      )}`,
      url: createOdooURL('documents'),
    },
    {
      icon: 'mdi:table', // Icône représentant une feuille de calcul
      title: `${translate('upComingAppsPage.finance.spreadsheet.title')}`,
      description: `${translate(
        'upComingAppsPage.finance.spreadsheet.description'
      )}`,
    },
    {
      icon: 'mdi:signature', // Icône représentant une signature
      title: `${translate('upComingAppsPage.finance.sign.title')}`,
      description: `${translate('upComingAppsPage.finance.sign.description')}`,
      url: createOdooURL('signature'),
    },
  ];

  return (
    <>
      <Helmet>
        <title> {`${translate('upComingAppsPage.title')}`} </title>
      </Helmet>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Typography
            variant="h3"
            paragraph
            align="center"
            sx={{ marginTop: '70px', marginBottom: '100px' }}
          >
            {`${translate('upComingAppsPage.appList')}`}
          </Typography>

          <Grid container spacing={12} sx={{ maxWidth: '1000px' }}>
            <Grid item>
              <Typography variant="h4" paragraph>
                {`${translate('upComingAppsPage.finance.title')}`}
              </Typography>

              <Typography sx={{ marginBottom: '20px' }}>
                {`${translate('upComingAppsPage.finance.description')}`}
              </Typography>

              <Grid container spacing={2}>
                {cardsFinances.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardActionArea
                        component="a"
                        href={card.url}
                        target="_bank"
                      >
                        <CardContent
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <div>
                            <Icon
                              icon={card.icon}
                              width={32}
                              style={{ marginRight: 16 }}
                            />
                          </div>
                          <div>
                            <Typography variant="h6">{card.title}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {card.description}
                            </Typography>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Typography variant="h4" sx={{ marginTop: '80px' }} align="center">
            {`${translate('upComingAppsPage.footer.line1')}`} <br />
            {`${translate('upComingAppsPage.footer.line2')}`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
